import React from 'react';

import { ColumnDefinition } from 'components/Grid/types';
import { OptionsOperator } from 'components/Grid/operators/Options';

import { EntityModules, ProtectorType } from 'core/constants';

import { formatLibraryId } from 'utils/formatters/libraryId';

import { HAZARD_FIELD, HAZARD_STATUS_LABEL, HazardStatusFilter } from '../../constants';
import { HazardRow } from '../../types';
import HazardStatusPill from '../HazardStatusPill';

const STATUS_OPTIONS = Object.values(HazardStatusFilter).map((value) => ({
  value,
  label: HAZARD_STATUS_LABEL[value],
}));

const renderLongText = ({ value }: { value: { value: string | null } }): React.ReactElement => (
  <span title={value?.value ?? undefined}>{value?.value}</span>
);

export const basicHazardsColumns = [
  {
    field: HAZARD_FIELD.id,
    headerName: 'ID',
    protectorType: ProtectorType.Number,
    renderCell: ({ value }: { value: { value: number | null } }) => formatLibraryId(EntityModules.Hazards, value.value),
  },
  {
    field: HAZARD_FIELD.name,
    headerName: 'Hazard',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: HAZARD_FIELD.category,
    headerName: 'Category',
    protectorType: ProtectorType.SingleChoice,
    pickerFilter: true,
  },
  {
    field: HAZARD_FIELD.whoMightBeHarmed,
    headerName: 'Who might be harmed',
    protectorType: ProtectorType.LongText,
    renderCell: renderLongText,
  },
  {
    field: HAZARD_FIELD.howMightBeHarmed,
    headerName: 'How might they be harmed',
    protectorType: ProtectorType.LongText,
    renderCell: renderLongText,
  },
  {
    field: 'libraryStatus',
    headerName: 'Status',
    width: 150,
    sortable: false,
    nativeFilter: 'status',
    filterOperators: OptionsOperator(STATUS_OPTIONS, { allowIsNot: true }),
    renderCell: ({ row }: { row: HazardRow }) => <HazardStatusPill archived={Boolean(row.archivedAt)} />,
  },
] as unknown as ColumnDefinition[];
